module.exports = __webpack_public_path__ + "static/media/picInfoRegisterSDDRA.54a2b395.jpg";